import styled from 'styled-components';
import { Container } from '../../layout/Container';

export const DeliveryContainer = styled(Container)`
  position: relative;
  max-width: 80rem;
  display: grid;
`;
